<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.clinic_address.title')}}</h4>

          <h6>{{$t('message.clinic_address.address')}}</h6>
          <bs-input :label="$t('message.clinic_address.address_th')" v-model="clinic.th.b_addr" :placeholder="$t('message.clinic_address.address_th')"></bs-input>
          <bs-input :label="$t('message.clinic_address.address_en')" v-model="clinic.en.b_addr" :placeholder="$t('message.clinic_address.address_en')"></bs-input>

          <div class='form-divider'></div>

          <label for="provice">{{$t('message.clinic_address.province')}}</label>
          <multiselect id="provice" 
                    class="multi-select-form"
                    v-model="selectedProvince" 
                    :placeholder="$t('message.clinic_address.province')" 
                    :options="refProvinces" 
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>

          <label for="district">{{$t('message.clinic_address.district')}}</label>
          <multiselect id="district" 
                    class="multi-select-form"
                    v-model="selectedDistrict" 
                    :placeholder="$t('message.clinic_address.district')" 
                    :options="refDistricts" 
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>

          <div class='form-divider'></div>

          <h6>{{$t('message.clinic_address.insurances')}}</h6>
          <multiselect id="insurances" 
                    class="multi-select-form"
                    v-model="selectedInsurance" 
                    :placeholder="$t('message.clinic_address.insurances')" 
                    :options="allInsurances" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="name" 
                    track-by="name"></multiselect>

          <div class='form-divider'></div>
          <h6>{{$t('message.clinic_address.contact_info')}}</h6>
          <bs-input v-model="clinic.clinic_email" :label="$t('message.clinic_address.email')" :placeholder="$t('message.clinic_address.email')"></bs-input>
          <bs-input v-model="clinic.website" :label="$t('message.clinic_address.website')" :placeholder="$t('message.clinic_address.website')"></bs-input>
          <bs-input v-model="clinic.facebook" :label="$t('message.clinic_address.facebook')" :placeholder="$t('message.clinic_address.facebook')"></bs-input>

          <div class='form-divider'></div>
          <h6>{{$t('message.clinic_address.clinic_map')}}</h6>
          <gmap-autocomplete class="place-input form-control"
                            :placeholder="$t('message.clinic_address.nearby_search')"
                            :select-first-on-enter="true" 
                            @place_changed="updatePlace($event)">
          </gmap-autocomplete>
          <google-map :center.sync="mapCenter"
                      map-type-id="terrain"
                      :zoom="15">
            <gmap-marker :position.sync="markPosition" 
                      :clickable="true" :draggable="true"
                      @dragend="setPosition" >
            </gmap-marker>
          </google-map>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="cancelChange">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <slot name='loader'></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alertbar from '@/components/AlertBar'
import { input as BsInput } from 'vue-strap'
import {load, Map as GoogleMap, Marker as GmapMarker, Autocomplete as GmapAutocomplete} from 'vue2-google-maps'
import Multiselect from 'vue-multiselect'

load({
  key: 'AIzaSyDQfPboNp8M8hdPiafwxu5xBo-StuWDpXI',
  v: '3.28', // Google Maps API version
  libraries: ['places'] // for auto search location by name
})

export default {
  components: {
    BsInput,
    GoogleMap,
    GmapMarker,
    GmapAutocomplete,
    Multiselect,
    Alertbar
  },
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      selectedProvince: null,
      selectedDistrict: null,
      selectedInsurance: null, // TODO
      refProvinces: [],
      refDistricts: [],
      allInsurances: [],
      allProvinces: [] // store all province fetched from the server
    }
  },
  methods: {
    updatePlace (pos) {
      // update center
      this.clinic.lat = pos.geometry.location.lat()
      this.clinic.long = pos.geometry.location.lng()
    },
    setPosition (pos) {
      this.clinic.lat = pos.latLng.lat()
      this.clinic.long = pos.latLng.lng()
    },
    saveAndContinue () {
      // work with sync modifier
      this.clinic.province_id = this.selectedProvince.value
      this.clinic.district_id = this.selectedDistrict.value
      this.$emit('update:clinic', this.clinic)

      // finish step with changed data
      this.$emit('finishStep', {
        th: { b_addr: this.clinic.th.b_addr },
        en: { b_addr: this.clinic.en.b_addr },
        website: this.clinic.website,
        facebook: this.clinic.facebook,
        clinic_email: this.clinic.clinic_email,
        province_id: this.selectedProvince.value,
        district_id: this.selectedDistrict.value,
        lat: this.clinic.lat,
        long: this.clinic.long,
        insurances: this.selectedInsurance.map((obj) => {
          return obj.id
        })
      })
    },
    cancelChange () {
      this.$emit('cancelChange')
    }
  },
  computed: {
    mapCenter () {
      return { lat: +this.clinic.lat, lng: +this.clinic.long }
    },
    markPosition () {
      return { lat: +this.clinic.lat, lng: +this.clinic.long }
    }
  },
  created () {
    this.$http.get(this.$APP_CONFIG.api.provinces(), { credentials: true }).then(res => {
      this.allProvinces = res.body
      this.refProvinces = res.body.map(p => { return { value: p.id, label: p.name } })

      // reload district and province
      if (this.clinic.province_id) {
        this.selectedProvince = this.refProvinces.find(r => r.value === this.clinic.province_id)
        setTimeout(() => {
          if (this.clinic.district_id) {
            this.selectedDistrict = this.refDistricts.find(d => d.value === this.clinic.district_id)
          }
        }, 0) // delay for finishing trigger province changed
      }
    })

    // Get insurance
    this.$http.get(this.$APP_CONFIG.api.insurance(), { credentials: true }).then(res => {
      this.allInsurances = res.body
      this.selectedInsurance = this.clinic.insurances
    })
  },
  watch: {
    selectedProvince (newValue, old) {
      let _province = this.allProvinces.find(p => p.id === newValue.value)
      this.refDistricts = _province.districts.map(d => { return { value: d.id, label: d.name } })
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../../assets/base_container";

.vue-map-container {
  width:100%;
  height: 500px;
  display: block;
  margin-bottom: 2em;
}

.place-input {
  z-index: 100;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Address.vue?b7fdf17e